import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=da3f2fe4&"
import script from "./Polls.vue?vue&type=script&lang=js&"
export * from "./Polls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VSheet})
